import axios from 'axios';
import { downloadAppCopyJson } from './appCopyExport';
import type { AppCopySourceCatalog } from './appCopyTypes';

const CATALOG_PATH = '/generated/app-copy-catalog.json';

export async function loadAppCopySourceCatalog(): Promise<AppCopySourceCatalog> {
  const publicUrl = process.env.PUBLIC_URL ?? '';
  const response = await axios.get<AppCopySourceCatalog>(`${publicUrl}${CATALOG_PATH}`, {
    responseType: 'json',
  });
  return response.data;
}

export async function exportAppCopyJson(): Promise<void> {
  const sourceCatalog = await loadAppCopySourceCatalog();
  downloadAppCopyJson({ document, sourceCatalog });
}
